class CartRemoveButton extends HTMLElement {
	constructor() {
		super();
		this.addEventListener("click", (event) => {
			event.preventDefault();
			const cartItems =
				this.closest("cart-items") || this.closest("cart-drawer-items");
			cartItems.updateQuantity(this.dataset.index, 0);
		});
	}
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
	constructor() {
		super();

		this.lineItemStatusElement =
			document.getElementById("shopping-cart-line-item-status") ||
			document.getElementById("CartDrawer-LineItemStatus");

		this.currentItemCount = Array.from(
			this.querySelectorAll('[name="updates[]"]')
		).reduce(
			(total, quantityInput) => total + parseInt(quantityInput.value),
			0
		);

		this.debouncedOnChange = debounce((event) => {
			this.onChange(event);
		}, 300);

		this.addEventListener("change", this.debouncedOnChange.bind(this));
		this.putBlockBas()
	}

	onChange(event) {
		let isReturnRequest = event.target.classList.contains('checkbox-reprise');
		!isReturnRequest && this.updateQuantity(
			event.target.dataset.index,
			event.target.value,
			document.activeElement.getAttribute("name"),
		);
	}

	putBlockBas() {
		if (window.screen.width < 992) {
			const targetContainer = document.querySelector('cart-items .cart__footer');
			const swiperCollection = document.querySelector('#featured-collection-cart');
			const targetReturn = document.querySelector('.cart__ctas');
			const returnElement = document.querySelector('.return-block');
			swiperCollection !== null && targetContainer.insertAdjacentElement('beforeend', swiperCollection)
			returnElement !== null && targetReturn.insertAdjacentElement('afterend', returnElement)
		}
	}

	getSectionsToRender() {
		return [
			{
				id: "ax_cart",
				section: document.getElementById("ax_cart").dataset.id,
				selector: ".js-contents",
			},
			{
				id: "cart-icon-bubble",
				section: "cart-icon-bubble",
				selector: ".shopify-section",
			},
			{
				id: "cart-live-region-text",
				section: "cart-live-region-text",
				selector: ".shopify-section",
			},
		];
	}

	updateQuantity(line, quantity, name) {
		this.enableLoading(line);


		let body = JSON.stringify({
			line,
			quantity,
			sections: this.getSectionsToRender().map((section) => section.section),
			sections_url: window.location.pathname,
		});

		return fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{body}})
			.then((response) => {
				return response.text();
			})
			.then((state) => {
					const parsedState = JSON.parse(state);
					this.classList.toggle("is-empty", parsedState.item_count === 0);
					const cartDrawerWrapper = document.querySelector("cart-drawer");
					const cartFooter = document.getElementById("main-cart-footer");

					// Supprimer la reprise si le panier est vide
					this.deleteReprise(state)

					if (cartFooter)
						cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
					if (cartDrawerWrapper)
						cartDrawerWrapper.classList.toggle(
							"is-empty",
							parsedState.item_count === 0
						);

					this.getSectionsToRender().forEach((section) => {
						const elementToReplace =
							document
								.getElementById(section.id)
								.querySelector(section.selector) ||
							document.getElementById(section.id);
						elementToReplace.innerHTML = this.getSectionInnerHTML(
							parsedState.sections[section.section],
							section.selector
						);
					});

					this.updateLiveRegions(line, parsedState.item_count);
					const lineItem =
						document.getElementById(`CartItem-${line}`) ||
						document.getElementById(`CartDrawer-Item-${line}`);
					if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
						cartDrawerWrapper
							? trapFocus(
								cartDrawerWrapper,
								lineItem.querySelector(`[name="${name}"]`)
							)
							: lineItem.querySelector(`[name="${name}"]`).focus();
					} else if (parsedState.item_count === 0 && cartDrawerWrapper) {
						trapFocus(
							cartDrawerWrapper.querySelector(".drawer__inner-empty"),
							cartDrawerWrapper.querySelector("a")
						);
					} else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
						trapFocus(
							cartDrawerWrapper,
							document.querySelector(".cart-item__name")
						);
					}

					this.reloadWidgets();

					const refreshEvent = new Event('refresh-card');
					document.dispatchEvent(refreshEvent);

					this.disableLoading();
					this.putBlockBas();
				}
			)
			.catch(
				(error) => {
					this
						.querySelectorAll(
							".loading-overlay"
						).forEach(
						(
							overlay
						) =>
							overlay
								.classList
								.add(
									"hidden"
								)
					)
					;
					console.log('Une erreur est survenue : ', error);

					const
						errors =
							document.getElementById("cart-errors") ||
							document.getElementById("CartDrawer-CartErrors");
					errors
						.textContent = window.cartStrings.error;
					this
						.disableLoading();
				}
			)
			;
	}

	reloadWidgets() {
		// Reload Trustpilot
		if (Trustpilot && document.querySelector('#main-cart-footer .trustpilot-widget')) {
			document.querySelectorAll('#main-cart-footer .trustpilot-widget').forEach(el => {
				(Trustpilot.loadFromElement(el), true);
			});
		}
	}
	
	deleteReprise(state) {
		const parsedState = JSON.parse(state);
		// Supprimer la reprise si le panier est vide
		if (parsedState.item_count === 1) {
			if (parsedState.items[0].handle == 'reprise') {
				this.enableLoading(1);  // Affiche le loader
				this.updateQuantity(1, 0).finally(() => {
					this.disableLoading(1);
				});
			}
		}
	}

	updateLiveRegions(line, itemCount) {
		this.currentItemCount = itemCount;
		this.lineItemStatusElement.setAttribute("aria-hidden", true);

		const cartStatus =
			document.getElementById("cart-live-region-text") ||
			document.getElementById("CartDrawer-LiveRegionText");
		cartStatus.setAttribute("aria-hidden", false);

		setTimeout(() => {
			cartStatus.setAttribute("aria-hidden", true);
		}, 1000);
	}

	getSectionInnerHTML(html, selector) {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector).innerHTML;
	}

	enableLoading(line) {
		const mainCartItems =
			document.getElementById("main-cart-items") ||
			document.getElementById("CartDrawer-CartItems");
		mainCartItems.classList.add("cart__items--disabled");

		const cartItemElements = this.querySelectorAll(
			`#CartItem-${line} .loading-overlay`
		);
		const cartDrawerItemElements = this.querySelectorAll(
			`#CartDrawer-Item-${line} .loading-overlay`
		);

		[...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
			overlay.classList.remove("hidden")
		);

		document.activeElement.blur();
		this.lineItemStatusElement.setAttribute("aria-hidden", false);
	}

	disableLoading() {
		const mainCartItems =
			document.getElementById("main-cart-items") ||
			document.getElementById("CartDrawer-CartItems");
		mainCartItems.classList.remove("cart__items--disabled");
	}
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
	customElements.define(
		"cart-note",
		class CartNote extends HTMLElement {
			constructor() {
				super();

				this.addEventListener(
					"change",
					debounce((event) => {
						const body = JSON.stringify({note: event.target.value});
						fetch(`${routes.cart_update_url}`, {
							...fetchConfig(),
							...{body},
						});
					}, 300)
				);
			}
		}
	);
}

class ReturnChoices extends HTMLElement {
	constructor() {
		super();
		this.init();
	}

	init() {
		const returnTitle = document.querySelector(".return-title");
		returnTitle.addEventListener("click", () => {
			this.classList.toggle("active");
		});
	}
}

customElements.define("return-choices", ReturnChoices);

class CheckboxChoice extends CartItems {
	constructor() {
		super();
		this.checkbox = this.querySelectorAll(".checkbox");
		this.updateData = {updates: {}};
		this.init();
	}

	init() {
		this.checkbox.forEach((checkbox) => {
			checkbox.addEventListener("click", (event) => {
				if (event.target.checked === true) {
					this.disableCheckbox();
					this.createFormData(checkbox);
				} else {
					this.disableCheckbox();
					this.createFormData()
				}
			});
		});
	}

	createFormData(selected) {
		if (selected) {
			this.checkbox.forEach((checkbox) => {
				this.updateData["updates"][parseInt(checkbox.dataset.formId)] = selected === checkbox ? 1 : 0;
			});
		} else {
			this.checkbox.forEach((checkbox) => {
				this.updateData["updates"][parseInt(checkbox.dataset.formId)] = 0;
			});
		}

		this.updateCart(this.updateData["updates"]);
	}

	disableCheckbox() {
		this.checkbox.forEach((checkbox) => {
			checkbox.disabled = true;
		});
	}

	updateCart(updates) {
		let body = JSON.stringify({
			updates,
			sections: this.getSectionsToRender().map((section) => section.section),
			sections_url: window.location.pathname,
		});

		fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{body}})
			.then((response) => {
				return response.text();
			})
			.then((state) => {
				const parsedState = JSON.parse(state);
				const cartItem = document.getElementsByTagName('cart-items')[0]
				cartItem.classList.toggle("is-empty", parsedState.item_count === 0);
				const cartDrawerWrapper = document.querySelector("cart-drawer");
				const cartFooter = document.getElementById("main-cart-footer");

				if (cartFooter)
					cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
				if (cartDrawerWrapper)
					cartDrawerWrapper.classList.toggle(
						"is-empty",
						parsedState.item_count === 0
					);

				this.getSectionsToRender().forEach((section) => {
					const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
					elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
				});
				const refreshEvent = new Event('refresh-card');
				document.dispatchEvent(refreshEvent);
			})
			.catch((error) => {
				console.error("Error:", error);
			})
	}
}

customElements.define("checkbox-choice", CheckboxChoice);

